import { render, staticRenderFns } from "./TipoMedidaForm.vue?vue&type=template&id=36379f42"
import script from "./TipoMedidaForm.vue?vue&type=script&lang=js"
export * from "./TipoMedidaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports